export default function Atu2ViewSwitch({ current }: Props) {
  return (
    <nav className="atu2-view-switch" aria-label="ATU2 2.0 화면 선택">
      <a className={current === 'decision' ? 'active' : ''} href="/atu2-lab-fable">
        운영 판단
      </a>
      <a className={current === 'technical' ? 'active' : ''} href="/atu2-lab">
        기술 상세
      </a>
    </nav>
  );
}

type Props = { current: 'decision' | 'technical' };
